// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__ibGWw","location":"LocationSection_location__g7tOG"};